/* unplugin-vue-components disabled */import { render } from "./left-controls.vue?vue&type=template&id=6db1427e&scoped=true"
import script from "./left-controls.vue?vue&type=script&lang=js"
export * from "./left-controls.vue?vue&type=script&lang=js"

import "./left-controls.vue?vue&type=style&index=0&id=6db1427e&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6db1427e"],['__file',"src/components/chat-input-v2/left-controls.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6db1427e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6db1427e', __exports__)) {
    api.reload('6db1427e', __exports__)
  }
  
  module.hot.accept("./left-controls.vue?vue&type=template&id=6db1427e&scoped=true", () => {
    api.rerender('6db1427e', render)
  })

}


export default __exports__